import "../.././styles/Constitution.css";

function ArticleTen() {
    return(
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE X: OFFICIAL SEAL OF THE CORPORATION</h3>
                    <h5>10.1 Official Seal of the Corporation</h5>
                    <p>
                        The Corporation shall have a corporate seal in a form determined by the Governing Board, and
                        the Governing Board shall determine the manner in which the seal will be used in connection
                        with the execution of documents on behalf of the Corporation.
                    </p>
                </div>
            </div>
    );
}

export default ArticleTen;